var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"settings-wrapper"}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"fab":"","icon":""},on:{"click":function($event){_vm.dark = !_vm.dark}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"large":"","color":"amber"}},[_vm._v("mdi-theme-light-dark")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t("setting.darkMode")))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }